<button mat-stroked-button
        class="secondary-button w-56"
        [disabled]="disabled() ||showLoader() ">
  @if (showLoader()) {
    <div class="flex">
      <mat-spinner [diameter]="20"></mat-spinner>
      <span>Procesando...</span>
    </div>

  } @else {
    {{ text() }}
  }
</button>
